var callbackMap = {};

var addCallback = function addCallback(eventType, aggregateId, eventCallback, resubscribeCallback) {
  if (!callbackMap[eventType]) {
    callbackMap[eventType] = {};
  }

  if (!callbackMap[eventType][aggregateId]) {
    callbackMap[eventType][aggregateId] = [];
  }

  callbackMap[eventType][aggregateId].push([eventCallback, resubscribeCallback]);
};

var removeCallback = function removeCallback(eventType, aggregateId, eventCallback) {
  callbackMap[eventType][aggregateId] = callbackMap[eventType][aggregateId].filter(function (f) {
    return f[0] !== eventCallback;
  });
};

var rootCallback = function rootCallback(event, resubscribed) {
  var type = event.type,
      aggregateId = event.aggregateId;

  var _loop = function _loop(eventType) {
    if (eventType === type) {
      var _callbackMap$eventTyp;

      var listeners = [];
      var wildcard = (_callbackMap$eventTyp = callbackMap[eventType]['*']) !== null && _callbackMap$eventTyp !== void 0 ? _callbackMap$eventTyp : [];
      var aggregateIdListeners = [];

      if (aggregateId !== '*') {
        var _callbackMap$eventTyp2;

        aggregateIdListeners = (_callbackMap$eventTyp2 = callbackMap[eventType][aggregateId]) !== null && _callbackMap$eventTyp2 !== void 0 ? _callbackMap$eventTyp2 : [];
      }

      listeners = listeners.concat(wildcard).concat(aggregateIdListeners);

      if (listeners) {
        if (resubscribed) {
          listeners.forEach(function (listener) {
            return listener[1] && listener[1]({
              eventType: eventType,
              aggregateId: aggregateId
            });
          });
        } else {
          listeners.forEach(function (listener) {
            return listener[0](event);
          });
        }
      }
    }
  };

  for (var eventType in callbackMap) {
    _loop(eventType);
  }
};

var dropCallbackMap = function dropCallbackMap() {
  callbackMap = {};
};

export { rootCallback, addCallback, removeCallback, dropCallbackMap };
//# sourceMappingURL=subscribe-callback.js.map